<template>
    <div class="creation-recla">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{name: 'home'}">Menu</router-link></li>
                <li v-if="selectedEvenement" class="breadcrumb-item"><router-link :to="{name: 'evenements'}">Evenement {{selectedEvenement}}</router-link></li>
                <li v-if="selectedAction" class="breadcrumb-item"><router-link :to="{name: 'actions'}">Action {{selectedAction}}</router-link></li>
            </ol>
        </nav>
        <transition name="fade" mode="out-in">
        <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "CreationSuivi",
        computed : {
            ...mapGetters('evenements', ['selectedEvenement']),
            ...mapGetters('actions', ['selectedAction'])
        },
        methods: {
            ...mapActions('title', ['setTitle'])
        },
        mounted() {
            this.setTitle('Saisie d\'un suivi')
        }
    }
</script>

<style scoped>

    @import "../assets/icon-list.css";

    .creation-recla{
        margin: 0px 10px;
    }
</style>